import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot } from '@angular/router';
// import { Observable } from 'rxjs';
import { NxiAuthService } from './index';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
@Injectable()
export class PortalAuthGuard implements CanActivate, CanActivateChild {

    constructor(private portalService: NxiAuthService, private http: HttpClient, private location: Location) { }

    // canActivateChild(activeRoute: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    //     return this.canActivate(activeRoute);
    // }
    async canActivateChild(activeRoute: ActivatedRouteSnapshot): Promise<boolean> {
        return await this.canActivate(activeRoute);
    }
    // canActivate(activeRoute: ActivatedRouteSnapshot): Observable<boolean> | boolean {
        async canActivate(activeRoute: ActivatedRouteSnapshot): Promise<boolean> {
        return await this.portalService.getMenuConfig().then((data) => {
            console.log( ' canActivate ' , data);
            this.portalService.invokeAsyncKeepAlive(activeRoute).subscribe();
            return true;
        });
        // this.portalService.invokeAsyncKeepAlive(activeRoute).subscribe();
        // return true;
    }

}
